// RawMaterialTable.js - Table for displaying raw materials (admin)
import React from "react";
import { tableContainer, tableBase, tableHead, tableHeader, tableCell, tableRow } from '../../../utils/tableStyle';
import ProductImageFallback from '../../CommonComponents/ProductImageFallback';
import TableActionButtons from '../../CommonComponents/TableActionButtons';
import EmptyState from '../../CommonComponents/EmptyState';

const RawMaterialImage = ({ image_url, name, uploadsBaseURL }) => {
    const [src, setSrc] = React.useState(image_url ? `${uploadsBaseURL}/${image_url}` : null);

    return (
        <div className="relative h-10 w-10">
            {src ? (
                <img
                    src={src}
                    alt={name}
                    className="h-10 w-10 object-cover rounded border"
                    onError={() => setSrc(null)}
                />
            ) : (
                <ProductImageFallback className="h-10 w-10 rounded" aria-label="No image" />
            )}
        </div>
    );
};

const RawMaterialTable = ({ materials, onEdit, onDelete, uploadsBaseURL }) => {
    if (!materials || materials.length === 0) return <EmptyState message="No raw materials found." icon="package" />;

    return (
        <div className={tableContainer}>
            <table className={tableBase}>
                <thead className={tableHead} style={{ background: 'var(--color-primary)' }}>
                    <tr>
                        <th className={tableHeader + ' text-center'}>Image</th>
                        <th className={tableHeader + ' text-center'}>Code</th>
                        <th className={tableHeader + ' text-center'}>Name</th>
                        <th className={tableHeader + ' text-center'}>Unit</th>
                        <th className={tableHeader + ' text-center'}>Created</th>
                        <th className={tableHeader + ' text-center'}>Updated</th>
                        <th className={tableHeader + ' text-center'}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {materials.map((mat) => (
                        <tr className={tableRow} key={mat.id}>
                            <td className={tableCell + ' text-center'}>
                                <div className="flex items-center justify-center">
                                    <RawMaterialImage
                                        image_url={mat.image_url}
                                        name={mat.name}
                                        uploadsBaseURL={uploadsBaseURL}
                                    />
                                </div>
                            </td>
                            <td className={tableCell + ' text-center'}>{mat.code || '-'}</td>
                            <td className={tableCell + ' text-center'}>{mat.name}</td>
                            <td className={tableCell + ' text-center'}>{mat.unit_type || '-'}</td>
                            <td className={tableCell + ' text-center'}>{mat.created_at ? new Date(mat.created_at).toLocaleDateString() : '-'}</td>
                            <td className={tableCell + ' text-center'}>{mat.updated_at ? new Date(mat.updated_at).toLocaleDateString() : '-'}</td>
                            <td className={tableCell + ' text-center'}>
                                <div className="flex items-center justify-center h-full gap-2 min-h-[40px]">
                                    <TableActionButtons
                                        canEdit={true}
                                        canDelete={true}
                                        onEdit={() => onEdit(mat)}
                                        onDelete={() => onDelete(mat)}
                                    />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default RawMaterialTable;
